module.exports = __webpack_public_path__ + "static/media/pdf.3d17c449.svg";